var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schema"},[_c('div',{staticClass:"schema-body"},[_c('schema-content')],1),_c('schema-export',{ref:"export"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }